const initialState = null;

const deals = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_DEALS_DATA_SUCCESS':
            return Object.assign({},state,{ ...action.payload });
        default:
            return state;
    }
};

export default deals;



// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/deals.js